module.exports = __webpack_public_path__ + "images/emoji/hatching_chick.6bc65a046445158dc0a5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hatching_chick.png
// module id = ykJV
// module chunks = 13